import { useState, useEffect, useCallback } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../../services/firebase";
import { COLLECTIONS } from "../../../../services/collections";
import { useTenant } from "../../../../hooks/useTenant";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export default function useOperationalMetrics() {
    const { idTenant, user } = useTenant();
    const { features } = useAuthorization();

    const [loading, setLoading] = useState(true);
    const [mySalesTodayCount, setMySalesTodayCount] = useState(0);
    const [mySalesTodayTotal, setMySalesTodayTotal] = useState(0);

    const loadMetrics = useCallback(async () => {
        if (!idTenant || !user?.uid) {
            setLoading(false);
            return;
        }
        
        // Se a tenant não possui o módulo de vendas habilitado (ex: Plano Personal), pula a busca.
        // Utilizamos "features?.sales_point" para manter a estabilidade do hook e não causar loop!
        if (features && !features.sales_point) {
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const todayDate = new Date();
            todayDate.setHours(todayDate.getHours() - 3); // Ajuste básico para BRT
            const todayStr = todayDate.toISOString().split("T")[0];

            const salesRef = collection(db, "tenants", idTenant, COLLECTIONS.SALES);

            const q = query(
                salesRef,
                where("date", "==", todayStr),
                where("idEmployee", "==", user.uid)
            );

            const snap = await getDocs(q);

            let count = 0;
            let total = 0;

            snap.docs.forEach(doc => {
                const data = doc.data();
                count++;
                total += (Number(data.netAmount) || Number(data.totalAmount) || 0);
            });

            setMySalesTodayCount(count);
            setMySalesTodayTotal(total);

        } catch (error) {
            console.error("Erro ao buscar métricas operacionais:", error);
        } finally {
            setLoading(false);
        }
    }, [idTenant, user?.uid, features]);

    useEffect(() => {
        loadMetrics();
    }, [loadMetrics]);

    return {
        mySalesTodayCount,
        mySalesTodayTotal,
        loading,
        refresh: loadMetrics
    };
}
